import { USER_LOGIN_SUCCESS, USER_LOGOUT } from '../constants';

export default (state = {}, action) => {
    switch(action.type) {
        case USER_LOGIN_SUCCESS:
            return {
                ...state, 
                ...action.user, 
                permissions: action.permissions, 
                isAuthenticated: true
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/reducer_user.js